import { render, staticRenderFns } from "./TopBuyerCategories.vue?vue&type=template&id=5dba21fb&"
import script from "./TopBuyerCategories.vue?vue&type=script&lang=js&"
export * from "./TopBuyerCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports